class SmartstoreConnectController extends AbstractIntegrationController
	@register()

	integrationId: 'smartstore'
